import React from 'react';
import UserIP from '../UserIP';
import './style.scss';

function IPBanner() {
  return (
    <div className="ip-banner">
      <div className="ip-banner-content">
        <span className="ip-text">
          Your IP: <UserIP />
        </span>
        <span className="separator">•</span>
        <span className="network-text">
          Your Network: {' '}
          <span className="unprotected">
            Unprotected
          </span>
        </span>
      </div>
    </div>
  );
}

export default IPBanner; 